<script>
/* eslint-disable */
import moment from 'moment'

const PDCA = [
  {
    label: 'Plan',
    value: 'plan'
  },
  {
    label: 'Do',
    value: 'do'
  },
  {
    label: 'Check',
    value: 'check'
  },
  {
    label: 'Act',
    value: 'act'
  }
]
export default {
  data() {
    return {
      parrentScaffolding: {
        task: {
          'items': {
            'item-1': {
              type: 'Collumns',
              fieldName: '{this.root}',
              leftRightMode: true,
              css: [`col-12 col-md-8 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-4 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
              colBody: [
                {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-0 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                      },
                      {
                        'item-1': {
                          label: 'Tiêu đề',
                          type: 'TextField',
                          fieldName: 'title',
                          icon: 'fas fa-signature',
                          validation: 'required'
                        },
                        'item-2': {
                          label: 'P.D.C.A',
                          type: 'OptionGroup',
                          inline: true,
                          fieldName: 'pdca',
                          icon: 'fas fa-tasks',
                          clearable: true,
                          datasource: {
                            options: PDCA,
                            label: 'label',
                            value: 'value'
                          },
                          mapOptions: true,
                          validation: {
                            required: this.mode === 'CREATE'
                          }
                        }
                      }
                    ]
                  },
                  'item-2': {
                    label: 'Mô tả',
                    type: 'WYSIWYG',
                    fieldName: 'description',
                    upload: {
                      fieldName: 'descriptionFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      label: 'Đính kèm',
                      chipMode: true,
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    }
                  },
                  'item-3': {
                    'indexColumn': false,
                    'label': 'Công việc con',
                    'dataType': 'SingleArray',
                    'editable': true,
                    'canCreate': true,
                    'canDelete': true,
                    'type': 'DataTableLink',
                    'hideBottom': true,
                    'pagination': {
                      'rowsPerPage': 0,
                      'descending': true
                    },
                    'linkMode': {
                      'route': {
                        'path': this.$route.path,
                        'name': this.$route.path,
                        'query': {
                          'id': 'props.row._id'
                        },
                        params: {
                          id: 'props.row._id',
                          mode: 'EDIT',
                          // data: dataFetched,
                          // scaffolding: this.parrentScaffolding[dataFetched.type.id]
                        }
                      },
                      'clickAbleProps': '_id'
                    },
                    'fieldName': 'subTask',
                    'addType': 'last',
                    'columns': [
                      {
                        label: 'Tiêu đề',
                        type: 'TextField',
                        field: 'title',
                        name: 'title',
                        fieldName: 'title',
                        validation: 'required'
                      },
                      {
                        label: 'P.D.C.A',
                        type: 'OptionGroup',
                        inline: true,
                        fieldName: 'pdca',
                        name: 'pdca',
                        field: 'pdca',
                        icon: 'fas fa-tasks',
                        clearable: true,
                        datasource: {
                          options: PDCA,
                          label: 'label',
                          value: 'value'
                        },
                        mapOptions: true,
                        validation: 'required',
                        '@tableOnly': {
                          showFormat: `this.R.path(['row', 'pdca'], props)`
                        }
                      },
                      {
                        label: 'Trạng thái',
                        type: 'Select',
                        validation: 'required',
                        field: 'status',
                        name: 'status',
                        fieldName: 'status',
                        useChip: true,
                        inputKey: 1,
                        default: {
                          id: 'new'
                        },
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'id',
                          color: 'color',
                          pickNext: {
                            pickDefault: 'new'
                          }
                        },
                        mapOptions: true,
                        '@tableOnly': {
                          'showFormat': 'props.row.status.label'
                        },
                        icon: 'linear_scale',
                        clearable: true,
                        sortBy: 'label'
                      },
                      {
                        label: 'Phòng ban phụ trách',
                        type: 'Select',
                        fieldName: 'department',
                        datasource: {
                          options: [],
                          field: 'listDep',
                          label: 'name',
                          value: 'id'
                        },
                        icon: 'store',
                        sortBy: 'name',
                        mapOptions: true,
                        clearable: true,
                        validation: 'required'
                      },
                      {
                        label: 'Độ ưu tiên',
                        type: 'Select',
                        validation: 'required',
                        field: 'priority',
                        name: 'priority',
                        useChip: true,
                        inputKey: 1,
                        '@tableOnly': {
                          'showFormat': 'props.row.priority.label'
                        },
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'id',
                          color: ['icon', 'color'],
                          icon: ['icon', 'name']
                        },
                        mapOptions: true,
                        sortBy: 'value',
                        icon: 'fas fa-angle-double-up',
                        clearable: true
                      },
                      {
                        label: 'Người phụ trách',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: 'required',
                        field: 'assignee',
                        name: 'assignee',
                        fieldName: 'assignee',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Người nhận kết quả',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: {
                          'required': true,
                          'email': true
                        },
                        field: 'reporter',
                        name: 'reporter',
                        fieldName: 'reporter',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Người cập nhật',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: {
                          'email': true
                        },
                        field: 'assistant',
                        name: 'assistant',
                        fieldName: 'assistant',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Hạn chót',
                        type: 'DatePicker',
                        validation: 'required',
                        field: 'dueDate',
                        fieldName: 'dueDate',
                        icon: 'date_range',
                        range: date => date >= moment().format('YYYY/MM/DD'),
                        clearable: true
                      }
                    ]
                  },
                  'item-4': {
                    label: 'Kết quả',
                    type: 'WYSIWYG',
                    fieldName: 'result',
                    upload: {
                      fieldName: 'resultFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    }
                  },
                },
                {
                  'item-1': {
                    label: 'Trạng thái',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'status',
                    useChip: true,
                    inputKey: 1,
                    default: {
                      id: 'new'
                    },
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: 'color',
                      pickNext: {
                        pickDefault: 'new'
                      },
                    },
                    mapOptions: true,
                    icon: 'linear_scale',
                    clearable: true,
                    sortBy: 'label'
                  },
                  'item-2': {
                    label: 'Độ ưu tiên',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'priority',
                    useChip: true,
                    inputKey: 1,
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: ['icon', 'color'],
                      icon: ['icon', 'name']
                    },
                    mapOptions: true,
                    icon: 'fas fa-angle-double-up',
                    clearable: true,
                    sortBy: 'value'
                  },
                  'item-2.1': {
                    label: 'Điểm',
                    type: 'Rating',
                    fieldName: 'points',
                    show: `@@{this.rootModel.status && (this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done'))}`
                  },
                  'item-2.2': {
                    label: 'Độ phức tạp',
                    type: 'Rating',
                    fieldName: 'complexity',
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-3': {
                    label: 'Tiến độ hoàn thành (%)',
                    type: 'Slider',
                    fieldName: 'progress',
                    min: 0,
                    max: 100,
                    step: 10,
                    color: 'green'
                  },
                  'item-4': {
                    label: 'Phòng ban phụ trách',
                    type: 'Select',
                    fieldName: 'department',
                    datasource: {
                      options: [],
                      field: 'listDep',
                      label: 'name',
                      value: 'id'
                    },
                    icon: 'store',
                    sortBy: 'name',
                    mapOptions: true,
                    clearable: true,
                    validation: 'required'
                  },
                  'item-5': {
                    label: 'Người phụ trách',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true
                    },
                    field: 'assignee',
                    name: 'assignee',
                    fieldName: 'assignee',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-6': {
                    label: 'Người nhận kết quả',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    field: 'reporter',
                    name: 'reporter',
                    fieldName: 'reporter',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-7': {
                    label: 'Người cập nhật',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'email': true
                    },
                    field: 'assistant',
                    name: 'assistant',
                    fieldName: 'assistant',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-8': {
                    label: 'Hạn chót',
                    type: 'DatePicker',
                    validation: 'required',
                    fieldName: 'dueDate',
                    icon: 'date_range',
                    clearable: true,
                    range: date => date >= moment().format('YYYY/MM/DD')
                  },
                  'item-9': {
                    label: 'Nhãn',
                    type: 'Select',
                    fieldName: 'labels',
                    icon: 'label',
                    clearable: true,
                    multiple: true,
                    useChipsMultiple: true,
                    newValueMode: 'add',
                    useInput: true
                  },
                  'item-10': {
                    label: 'Chia sẻ',
                    fieldName: 'listShareUser',
                    type: 'Select',
                    multiple: true,
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    useChipsMultiple: true,
                    icon: 'people',
                    clearable: true
                  },
                  'item-11': {
                    label: 'Người tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.value.createdBy`,
                    watch: true
                  },
                  'item-12': {
                    label: 'Ngày tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.createdTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-13': {
                    label: 'Cập nhật cuối',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.lastModifiedTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-14': {
                    label: 'Quá hạn',
                    type: 'Label',
                    fieldName: 'dueDate',
                    format: `(this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel' ? this.moment(this.modelProps.toDate()).fromNow() : '')`,
                    chipMode: true,
                    colorChip: `'red'`,
                    show: `this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel'`
                  },
                  'item-15': {
                    label: 'Công việc liên quan',
                    type: 'List',
                    fieldName: 'none',
                    items: [],
                    title: 'label',
                    caption: 'caption'
                  }
                }
              ]
            }
          }
        },
        task_readonly: {
          'items': {
            'item-1': {
              type: 'Collumns',
              fieldName: '{this.root}',
              leftRightMode: true,
              css: [`col-12 col-md-8 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-4 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
              colBody: [
                {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-0 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                      },
                      {
                        'item-1': {
                          label: 'Tiêu đề',
                          type: 'TextField',
                          fieldName: 'title',
                          icon: 'fas fa-signature',
                          validation: 'required',
                          readonly: true
                        },
                        'item-2': {
                          label: 'P.D.C.A',
                          type: 'OptionGroup',
                          inline: true,
                          fieldName: 'pdca',
                          icon: 'fas fa-tasks',
                          clearable: true,
                          datasource: {
                            options: PDCA,
                            mapOptions: true,
                          },
                          readonly: true
                        }
                      }
                    ]
                  },
                  'item-2': {
                    label: 'Mô tả',
                    type: 'WYSIWYG',
                    fieldName: 'description',
                    upload: {
                      fieldName: 'descriptionFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    },
                    readonly: true
                  },
                  'item-3': {
                    'indexColumn': false,
                    'label': 'Công việc con',
                    'dataType': 'SingleArray',
                    'editable': true,
                    'canCreate': true,
                    'canDelete': true,
                    'type': 'DataTableLink',
                    'hideBottom': true,
                    'pagination': {
                      'rowsPerPage': 0,
                      'descending': true
                    },
                    'linkMode': {
                      'route': {
                        'path': this.$route.path,
                        'name': this.$route.path,
                        'query': {
                          'id': 'props.row._id'
                        },
                        params: {
                          id: 'props.row._id',
                          mode: 'EDIT',
                          // data: dataFetched,
                          // scaffolding: this.parrentScaffolding[dataFetched.type.id]
                        }
                      },
                      'clickAbleProps': '_id'
                    },
                    'fieldName': 'subTask',
                    'addType': 'last',
                    'columns': [
                      {
                        label: 'Tiêu đề',
                        type: 'TextField',
                        field: 'title',
                        name: 'title',
                        fieldName: 'title',
                        validation: 'required'
                      },
                      {
                        label: 'P.D.C.A',
                        type: 'OptionGroup',
                        inline: true,
                        fieldName: 'pdca',
                        icon: 'fas fa-tasks',
                        clearable: true,
                        name: 'pdca',
                        field: 'pdca',
                        datasource: {
                          options: PDCA,
                          label: 'label',
                          value: 'value'
                        },
                        mapOptions: true,
                        readonly: true,
                        validation: 'required',
                        '@tableOnly': {
                          showFormat: `this.R.path(['row', 'pdca'], props)`
                        }
                      },
                      {
                        label: 'Trạng thái',
                        type: 'Select',
                        validation: 'required',
                        field: 'status',
                        name: 'status',
                        fieldName: 'status',
                        useChip: true,
                        inputKey: 1,
                        default: {
                          id: 'new'
                        },
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'id',
                          color: 'color',
                          pickNext: {
                            pickDefault: 'new'
                          }
                        },
                        mapOptions: true,
                        '@tableOnly': {
                          'showFormat': 'props.row.status.label'
                        },
                        icon: 'linear_scale',
                        clearable: true,
                        sortBy: 'label'
                      },
                      {
                        label: 'Phòng ban phụ trách',
                        type: 'Select',
                        fieldName: 'department',
                        datasource: {
                          options: [],
                          field: 'listDep',
                          label: 'name',
                          value: 'id'
                        },
                        icon: 'store',
                        sortBy: 'name',
                        mapOptions: true,
                        clearable: true,
                        validation: 'required'
                      },
                      {
                        label: 'Độ ưu tiên',
                        type: 'Select',
                        validation: 'required',
                        field: 'priority',
                        name: 'priority',
                        fieldName: 'priority',
                        useChip: true,
                        inputKey: 1,
                        '@tableOnly': {
                          'showFormat': 'props.row.priority.label'
                        },
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'id',
                          color: ['icon', 'color'],
                          icon: ['icon', 'name']
                        },
                        mapOptions: true,
                        sortBy: 'value',
                        icon: 'fas fa-angle-double-up',
                        clearable: true
                      },
                      {
                        label: 'Người phụ trách',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: 'required|email',
                        field: 'assignee',
                        name: 'assignee',
                        fieldName: 'assignee',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Người nhận kết quả',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: {
                          'required': true,
                          email: true
                        },
                        field: 'reporter',
                        name: 'reporter',
                        fieldName: 'reporter',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Người cập nhật',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: {
                          'email': true
                        },
                        field: 'assistant',
                        name: 'assistant',
                        fieldName: 'assistant',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Hạn chót',
                        type: 'DatePicker',
                        validation: 'required',
                        field: 'dueDate',
                        fieldName: 'dueDate',
                        icon: 'date_range',
                        range: date => date >= moment().format('YYYY/MM/DD'),
                        clearable: true
                      }
                    ]
                  },
                  'item-4': {
                    label: 'Kết quả',
                    type: 'WYSIWYG',
                    fieldName: 'result',
                    upload: {
                      fieldName: 'resultFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    }
                  },
                },
                {
                  'item-1': {
                    label: 'Trạng thái',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'status',
                    useChip: true,
                    inputKey: 1,
                    default: {
                      id: 'new'
                    },
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: 'color',
                      pickNext: {
                        pickDefault: 'new'
                      },
                    },
                    mapOptions: true,
                    icon: 'linear_scale',
                    clearable: true,
                    sortBy: 'label'
                  },
                  'item-2': {
                    label: 'Độ ưu tiên',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'priority',
                    useChip: true,
                    inputKey: 1,
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: ['icon', 'color'],
                      icon: ['icon', 'name']
                    },
                    mapOptions: true,
                    icon: 'fas fa-angle-double-up',
                    clearable: true,
                    sortBy: 'value',
                    readonly: true
                  },
                  'item-2.1': {
                    label: 'Điểm',
                    type: 'Rating',
                    fieldName: 'points',
                    readonly: true,
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-2.2': {
                    label: 'Độ phức tạp',
                    type: 'Rating',
                    fieldName: 'complexity',
                    readonly: true,
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-3': {
                    label: 'Tiến độ hoàn thành (%)',
                    type: 'Slider',
                    fieldName: 'progress',
                    min: 0,
                    max: 100,
                    step: 10,
                    color: 'green'
                  },
                  'item-4': {
                    label: 'Phòng ban phụ trách',
                    type: 'Select',
                    fieldName: 'department',
                    datasource: {
                      options: [],
                      field: 'listDep',
                      label: 'name',
                      value: 'id'
                    },
                    icon: 'store',
                    sortBy: 'name',
                    mapOptions: true,
                    clearable: true,
                    readonly: true,
                    validation: 'required'
                  },
                  'item-5': {
                    label: 'Người phụ trách',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    sortBy: 'displayName',
                    field: 'assignee',
                    name: 'assignee',
                    fieldName: 'assignee',
                    icon: 'people',
                    clearable: true,
                    readonly: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-6': {
                    label: 'Người nhận kết quả',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    field: 'reporter',
                    name: 'reporter',
                    fieldName: 'reporter',
                    icon: 'people',
                    clearable: true,
                    readonly: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-7': {
                    label: 'Người cập nhật',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'email': true
                    },
                    field: 'assistant',
                    name: 'assistant',
                    fieldName: 'assistant',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-8': {
                    label: 'Hạn chót',
                    type: 'DatePicker',
                    validation: 'required',
                    fieldName: 'dueDate',
                    icon: 'date_range',
                    clearable: true,
                    range: date => date >= moment().format('YYYY/MM/DD'),
                    readonly: true
                  },
                  'item-9': {
                    label: 'Nhãn',
                    type: 'Select',
                    fieldName: 'labels',
                    icon: 'label',
                    clearable: true,
                    multiple: true,
                    useChipsMultiple: true,
                    newValueMode: 'add',
                    useInput: true,
                    readonly: true
                  },
                  'item-10': {
                    label: 'Chia sẻ',
                    fieldName: 'listShareUser',
                    type: 'Select',
                    multiple: true,
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    useChipsMultiple: true,
                    icon: 'people',
                    clearable: true,
                    readonly: true
                  },
                  'item-11': {
                    label: 'Người tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.value.createdBy`,
                    watch: true
                  },
                  'item-12': {
                    label: 'Ngày tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.createdTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-13': {
                    label: 'Cập nhật cuối',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.lastModifiedTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-14': {
                    label: 'Quá hạn',
                    type: 'Label',
                    fieldName: 'dueDate',
                    format: `(this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel' ? this.moment(this.modelProps.toDate()).fromNow() : '')`,
                    chipMode: true,
                    colorChip: `'red'`,
                    show: `this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel'`
                  },
                  'item-15': {
                    label: 'Công việc liên quan',
                    type: 'List',
                    fieldName: 'none',
                    items: [],
                    title: 'label',
                    caption: 'caption'
                  }
                }
              ]
            }
          }
        },
        idea: {
          'items': {
            'item-1': {
              type: 'Collumns',
              fieldName: '{this.root}',
              leftRightMode: true,
              css: [`col-12 col-md-8 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-4 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
              colBody: [
                {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                        'item-2': {
                          type: 'TextField',
                          fieldName: 'title',
                          label: 'Tên sáng kiến',
                          icon: 'fas fa-signature'
                        },
                        'item-3': {
                          type: 'TextField',
                          fieldName: 'partner',
                          label: 'Đối tác',
                          icon: 'fas fa-handshake'
                        },
                        'item-4': {
                          type: 'TextField',
                          fieldName: 'target',
                          label: 'Mục tiêu',
                          icon: 'fas fa-dot-circle'
                        }
                      },
                      {
                        'item-1': {
                          type: 'Select',
                          fieldName: 'bu',
                          label: 'Đơn vị',
                          icon: 'business',
                          datasource: {
                            options: [],
                            label: 'label',
                            value: 'id'
                          },
                          sortBy: 'label'
                        },
                        'item-2': {
                          type: 'Select',
                          fieldName: 'ideaType',
                          label: 'Loại sáng kiến',
                          icon: 'highlight',
                          sortBy: 'label',
                          datasource: {
                            options: [],
                            label: 'label',
                            value: 'id'
                          }
                        },
                        'item-3': {
                          type: 'TextField',
                          fieldName: 'impact',
                          label: 'Tác động',
                          icon: 'fas fa-assistive-listening-systems'
                        }
                      }
                    ]
                  },
                  'item-2': {
                    label: 'Mô tả',
                    type: 'WYSIWYG',
                    fieldName: 'description',
                    upload: {
                      fieldName: 'descriptionFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    }
                  },
                  // 'item-3': {
                  //   'indexColumn': false,
                  //   'label': 'Công việc con',
                  //   'dataType': 'SingleArray',
                  //   'editable': true,
                  //   'canCreate': true,
                  //   'canDelete': true,
                  //   'type': 'DataTableLink',
                  //   'hideBottom': true,
                  //   'pagination': {
                  //     'rowsPerPage': 0,
                  //     'descending': true
                  //   },
                  //   'linkMode': {
                  //     'route': {
                  //       'path': this.$route.path,
                  //       'name': this.$route.path,
                  //       'query': {
                  //         'id': 'props.row._id'
                  //       },
                  //       params: {
                  //         id: 'props.row._id',
                  //         mode: 'EDIT',
                  //         // data: dataFetched,
                  //         // scaffolding: this.parrentScaffolding[dataFetched.type.id]
                  //       }
                  //     },
                  //     'clickAbleProps': '_id'
                  //   },
                  //   'fieldName': 'subTask',
                  //   'addType': 'last',
                  //   'columns': [
                  //     {
                  //       label: 'Tiêu đề',
                  //       type: 'TextField',
                  //       field: 'title',
                  //       name: 'title',
                  //       fieldName: 'title',
                  //       validation: 'required'
                  //     },
                  //     {
                  //       label: 'Trạng thái',
                  //       type: 'Select',
                  //       validation: 'required',
                  //       field: 'status',
                  //       name: 'status',
                  //       fieldName: 'status',
                  //       useChip: true,
                  //       inputKey: 1,
                  //       default: {
                  //         id: 'new'
                  //       },
                  //       datasource: {
                  //         options: [],
                  //         label: 'label',
                  //         value: 'id',
                  //         color: 'color',
                  //         pickNext: {
                  //           pickDefault: 'new'
                  //         },
                  //       },
                  //       '@tableOnly': {
                  //         'showFormat': 'props.row.status.label'
                  //       },
                  //       mapOptions: true,
                  //       icon: 'linear_scale',
                  //       clearable: true,
                  //       sortBy: 'label'
                  //     },
                  //     {
                  //       label: 'Phòng ban phụ trách',
                  //       type: 'Select',
                  //       fieldName: 'department',
                  //       datasource: {
                  //         options: [],
                  //         field: 'listDep',
                  //         label: 'name',
                  //         value: 'id'
                  //       },
                  //       icon: 'store',
                  //       sortBy: 'name',
                  //       mapOptions: true,
                  //       clearable: true,
                  //       validation: 'required'
                  //     },
                  //     {
                  //       label: 'Độ ưu tiên',
                  //       type: 'Select',
                  //       validation: 'required',
                  //       field: 'priority',
                  //       name: 'priority',
                  //       fieldName: 'priority',
                  //       useChip: true,
                  //       inputKey: 1,
                  //       '@tableOnly': {
                  //         'showFormat': 'props.row.priority.label'
                  //       },
                  //       datasource: {
                  //         options: [],
                  //         label: 'label',
                  //         value: 'id',
                  //         color: ['icon', 'color'],
                  //         icon: ['icon', 'name']
                  //       },
                  //       mapOptions: true,
                  //       icon: 'fas fa-angle-double-up',
                  //       clearable: true,
                  //       sortBy: 'value'
                  //     },
                  //     // {
                  //     //   label: 'Người phụ trách',
                  //     //   type: 'Select',
                  //     //   validation: 'required',
                  //     //   field: 'assignee',
                  //     //   name: 'assignee',
                  //     //   fieldName: 'assignee',
                  //     //   isLoading: true,
                  //     //   inputKey: 1,
                  //     //   datasource: {
                  //     //     options: [],
                  //     //     label: 'displayName',
                  //     //     value: 'email'
                  //     //   },
                  //     //   '@tableOnly': {
                  //     //     'showFormat': 'props.row.assignee.displayName'
                  //     //   },
                  //     //   icon: 'people',
                  //     //   clearable: true
                  //     // },
                  //     {
                  //       label: 'Người phụ trách',
                  //       type: 'Select',
                  //       datasource: {
                  //         options: [],
                  //         value: 'email',
                  //         label: 'displayName',
                  //         emitValue: true
                  //       },
                  //       sortBy: 'displayName',
                  //       mapOptions: true,
                  //       useInput: true,
                  //       validation: 'required|email',
                  //       field: 'assignee',
                  //       name: 'assignee',
                  //       fieldName: 'assignee',
                  //       icon: 'people',
                  //       clearable: true,
                  //       after: {
                  //         func: this.assignToMe
                  //       }
                  //     },
                  //     {
                  //       label: 'Người nhận kết quả',
                  //       type: 'Select',
                  //       datasource: {
                  //         options: [],
                  //         value: 'email',
                  //         label: 'displayName',
                  //         emitValue: true
                  //       },
                  //       mapOptions: true,
                  //       useInput: true,
                  //       validation: {
                  //         'required': true,
                  //         'email': true
                  //       },
                  //       sortBy: 'displayName',
                  //       field: 'reporter',
                  //       name: 'reporter',
                  //       fieldName: 'reporter',
                  //       icon: 'people',
                  //       clearable: true,
                  //       after: {
                  //         func: this.assignToMe
                  //       }
                  //     },
                  //     {
                  //       label: 'Người cập nhật',
                  //       type: 'Select',
                  //       datasource: {
                  //         options: [],
                  //         value: 'email',
                  //         label: 'displayName',
                  //         emitValue: true
                  //       },
                  //       sortBy: 'displayName',
                  //       mapOptions: true,
                  //       useInput: true,
                  //       validation: {
                  //         'email': true
                  //       },
                  //       field: 'assistant',
                  //       name: 'assistant',
                  //       fieldName: 'assistant',
                  //       icon: 'people',
                  //       clearable: true,
                  //       after: {
                  //         func: this.assignToMe
                  //       }
                  //     },
                  //     {
                  //       label: 'Hạn chót',
                  //       type: 'DatePicker',
                  //       validation: 'required',
                  //       field: 'dueDate',
                  //       fieldName: 'dueDate',
                  //       icon: 'date_range',
                  //       clearable: true,
                  //       range: date => date >= moment().format('YYYY/MM/DD')
                  //     }
                  //   ]
                  // },
                  'item-4': {
                    label: 'Kết quả',
                    type: 'WYSIWYG',
                    fieldName: 'result',
                    upload: {
                      fieldName: 'resultFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    }
                  }
                },
                {
                  'item-1': {
                    label: 'Trạng thái',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'status',
                    useChip: true,
                    inputKey: 1,
                    default: {
                      id: 'new'
                    },
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: 'color',
                      pickNext: {
                        pickDefault: 'new'
                      }
                    },
                    mapOptions: true,
                    icon: 'linear_scale',
                    clearable: true,
                    sortBy: 'label'
                  },
                  'item-2': {
                    label: 'Độ ưu tiên',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'priority',
                    useChip: true,
                    inputKey: 1,
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: ['icon', 'color'],
                      icon: ['icon', 'name']
                    },
                    mapOptions: true,
                    icon: 'fas fa-angle-double-up',
                    clearable: true,
                    sortBy: 'value'
                  },
                  'item-2.1': {
                    label: 'Điểm',
                    type: 'Rating',
                    fieldName: 'points',
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-2.2': {
                    label: 'Độ phức tạp',
                    type: 'Rating',
                    fieldName: 'complexity',
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-3': {
                    label: 'Tiến độ hoàn thành (%)',
                    type: 'Slider',
                    fieldName: 'progress',
                    min: 0,
                    max: 100,
                    step: 10,
                    color: 'green'
                  },
                  'item-4': {
                    label: 'Phòng ban phụ trách',
                    type: 'Select',
                    fieldName: 'department',
                    datasource: {
                      options: [],
                      field: 'listDep',
                      label: 'name',
                      value: 'id'
                    },
                    icon: 'store',
                    sortBy: 'name',
                    mapOptions: true,
                    clearable: true,
                    validation: 'required'
                  },
                  'item-5': {
                    label: 'Người phụ trách',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    sortBy: 'displayName',
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    field: 'assignee',
                    name: 'assignee',
                    fieldName: 'assignee',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-6': {
                    label: 'Người nhận kết quả',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    field: 'reporter',
                    name: 'reporter',
                    fieldName: 'reporter',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-7': {
                    label: 'Người cập nhật',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'email': true
                    },
                    field: 'assistant',
                    name: 'assistant',
                    fieldName: 'assistant',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-8': {
                    label: 'Hạn chót',
                    type: 'DatePicker',
                    validation: 'required',
                    fieldName: 'dueDate',
                    icon: 'date_range',
                    clearable: true,
                    range: date => date >= moment().format('YYYY/MM/DD')
                  },
                  'item-9': {
                    label: 'Nhãn',
                    type: 'Select',
                    fieldName: 'labels',
                    icon: 'label',
                    clearable: true,
                    multiple: true,
                    useChipsMultiple: true,
                    newValueMode: 'add',
                    useInput: true
                  },
                  'item-10': {
                    label: 'Chia sẻ',
                    fieldName: 'listShareUser',
                    type: 'Select',
                    multiple: true,
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    useChipsMultiple: true,
                    icon: 'people',
                    clearable: true
                  },
                  'item-11': {
                    label: 'Người tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.value.createdBy`,
                    watch: true
                  },
                  'item-12': {
                    label: 'Ngày tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.createdTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-13': {
                    label: 'Cập nhật cuối',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.lastModifiedTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-14': {
                    label: 'Quá hạn',
                    type: 'Label',
                    fieldName: 'dueDate',
                    format: `(this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel' ? this.moment(this.modelProps.toDate()).fromNow() : '')`,
                    chipMode: true,
                    colorChip: `'red'`,
                    show: `this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel'`
                  },
                  'item-15': {
                    label: 'Công việc liên quan',
                    type: 'List',
                    fieldName: 'none',
                    items: [],
                    title: 'label',
                    caption: 'caption'
                  }
                }
              ]
            }
          }
        },
        idea_readonly: {
          'items': {
            'item-1': {
              type: 'Collumns',
              fieldName: '{this.root}',
              leftRightMode: true,
              css: [`col-12 col-md-8 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-4 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
              colBody: [
                {
                  'item-1': {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
                    colBody: [
                      {
                        'item-2': {
                          type: 'TextField',
                          fieldName: 'title',
                          label: 'Tên sáng kiến',
                          icon: 'fas fa-signature',
                          readonly: true
                        },
                        'item-3': {
                          type: 'TextField',
                          fieldName: 'partner',
                          label: 'Đối tác',
                          icon: 'fas fa-handshake',
                          readonly: true
                        },
                        'item-4': {
                          type: 'TextField',
                          fieldName: 'target',
                          label: 'Mục tiêu',
                          icon: 'fas fa-dot-circle',
                          readonly: true
                        }
                      },
                      {
                        'item-1': {
                          type: 'Select',
                          fieldName: 'bu',
                          label: 'Đơn vị',
                          icon: 'business',
                          datasource: {
                            options: [],
                            label: 'label',
                            value: 'id'
                          },
                          sortBy: 'label',
                          readonly: true
                        },
                        'item-2': {
                          type: 'Select',
                          fieldName: 'ideaType',
                          label: 'Loại sáng kiến',
                          icon: 'highlight',
                          sortBy: 'label',
                          datasource: {
                            options: [],
                            label: 'label',
                            value: 'id'
                          },
                          readonly: true
                        },
                        'item-3': {
                          type: 'TextField',
                          fieldName: 'impact',
                          label: 'Tác động',
                          icon: 'fas fa-assistive-listening-systems',
                          readonly: true
                        }
                      }
                    ]
                  },
                  'item-2': {
                    label: 'Mô tả',
                    type: 'WYSIWYG',
                    fieldName: 'description',
                    upload: {
                      fieldName: 'descriptionFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    },
                    readonly: true
                  },
                  'item-3': {
                    'indexColumn': false,
                    'label': 'Công việc con',
                    'dataType': 'SingleArray',
                    'editable': true,
                    'canCreate': true,
                    'canDelete': true,
                    'type': 'DataTableLink',
                    'hideBottom': true,
                    'pagination': {
                      'rowsPerPage': 0,
                      'descending': true
                    },
                    'linkMode': {
                      'route': {
                        'path': this.$route.path,
                        'name': this.$route.path,
                        'query': {
                          'id': 'props.row._id'
                        },
                        params: {
                          id: 'props.row._id',
                          mode: 'EDIT',
                          // data: dataFetched,
                          // scaffolding: this.parrentScaffolding[dataFetched.type.id]
                        }
                      },
                      'clickAbleProps': '_id'
                    },
                    'fieldName': 'subTask',
                    'addType': 'last',
                    'columns': [
                      {
                        label: 'Tiêu đề',
                        type: 'TextField',
                        field: 'title',
                        name: 'title',
                        fieldName: 'title',
                        validation: 'required'
                      },
                      {
                        label: 'Trạng thái',
                        type: 'Select',
                        validation: 'required',
                        field: 'status',
                        name: 'status',
                        fieldName: 'status',
                        useChip: true,
                        inputKey: 1,
                        default: {
                          id: 'new'
                        },
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'id',
                          color: 'color',
                          pickNext: {
                            pickDefault: 'new'
                          },
                        },
                        '@tableOnly': {
                          'showFormat': 'props.row.status.label'
                        },
                        mapOptions: true,
                        icon: 'linear_scale',
                        clearable: true,
                        sortBy: 'label'
                      },
                      {
                        label: 'Phòng ban phụ trách',
                        type: 'Select',
                        fieldName: 'department',
                        datasource: {
                          options: [],
                          field: 'listDep',
                          label: 'name',
                          value: 'id'
                        },
                        icon: 'store',
                        sortBy: 'name',
                        mapOptions: true,
                        clearable: true,
                        validation: 'required'
                      },
                      {
                        label: 'Độ ưu tiên',
                        type: 'Select',
                        validation: 'required',
                        field: 'priority',
                        name: 'priority',
                        fieldName: 'priority',
                        useChip: true,
                        inputKey: 1,
                        '@tableOnly': {
                          'showFormat': 'props.row.priority.label'
                        },
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'id',
                          color: ['icon', 'color'],
                          icon: ['icon', 'name']
                        },
                        mapOptions: true,
                        icon: 'fas fa-angle-double-up',
                        clearable: true,
                        sortBy: 'value'
                      },
                      // {
                      //   label: 'Người phụ trách',
                      //   type: 'Select',
                      //   validation: 'required',
                      //   field: 'assignee',
                      //   name: 'assignee',
                      //   fieldName: 'assignee',
                      //   isLoading: true,
                      //   inputKey: 1,
                      //   datasource: {
                      //     options: [],
                      //     label: 'displayName',
                      //     value: 'email'
                      //   },
                      //   '@tableOnly': {
                      //     'showFormat': 'props.row.assignee.displayName'
                      //   },
                      //   icon: 'people',
                      //   clearable: true
                      // },
                      {
                        label: 'Người phụ trách',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        sortBy: 'displayName',
                        mapOptions: true,
                        useInput: true,
                        validation: 'required|email',
                        field: 'assignee',
                        name: 'assignee',
                        fieldName: 'assignee',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Người nhận kết quả',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        mapOptions: true,
                        useInput: true,
                        validation: {
                          'required': true,
                          'email': true
                        },
                        sortBy: 'displayName',
                        field: 'reporter',
                        name: 'reporter',
                        fieldName: 'reporter',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Người cập nhật',
                        type: 'Select',
                        datasource: {
                          options: [],
                          value: 'email',
                          label: 'displayName',
                          emitValue: true
                        },
                        mapOptions: true,
                        useInput: true,
                        validation: {
                          'email': true
                        },
                        field: 'assistant',
                        name: 'assistant',
                        fieldName: 'assistant',
                        icon: 'people',
                        clearable: true,
                        after: {
                          func: this.assignToMe
                        }
                      },
                      {
                        label: 'Hạn chót',
                        type: 'DatePicker',
                        validation: 'required',
                        field: 'dueDate',
                        fieldName: 'dueDate',
                        icon: 'date_range',
                        clearable: true,
                        range: date => date >= moment().format('YYYY/MM/DD')
                      }
                    ]
                  },
                  'item-4': {
                    label: 'Kết quả',
                    type: 'WYSIWYG',
                    fieldName: 'result',
                    upload: {
                      fieldName: 'resultFiles',
                      accept: '.jpg, .pdf, image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt',
                      maxFileSize: 10485760,
                      chipMode: true,
                      label: 'Đính kèm',
                      app: 'namis',
                      dialogScaffolding: {
                        'item-1': {
                          type: 'FileInput',
                          fieldName: 'file',
                          validation: 'required'
                        }
                      },
                      header: [
                        {
                          label: 'Tền file',
                          format: 'file.name'
                        }
                      ]
                    }
                  }
                },
                {
                  'item-1': {
                    label: 'Trạng thái',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'status',
                    useChip: true,
                    inputKey: 1,
                    default: {
                      id: 'new'
                    },
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: 'color',
                      pickNext: {
                        pickDefault: 'new'
                      }
                    },
                    mapOptions: true,
                    icon: 'linear_scale',
                    clearable: true,
                    sortBy: 'label'
                  },
                  'item-2': {
                    label: 'Độ ưu tiên',
                    type: 'Select',
                    validation: 'required',
                    fieldName: 'priority',
                    useChip: true,
                    inputKey: 1,
                    datasource: {
                      options: [],
                      label: 'label',
                      value: 'id',
                      color: ['icon', 'color'],
                      icon: ['icon', 'name']
                    },
                    mapOptions: true,
                    icon: 'fas fa-angle-double-up',
                    clearable: true,
                    sortBy: 'value',
                    readonly: true
                  },
                  'item-2.1': {
                    label: 'Điểm',
                    type: 'Rating',
                    fieldName: 'points',
                    readonly: true,
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-2.2': {
                    label: 'Độ phức tạp',
                    type: 'Rating',
                    fieldName: 'complexity',
                    readonly: true,
                    show: `@@{this.rootModel.status && (this.rootModel.status.id === 'done_pending' || this.rootModel.status.id === 'done')}`
                  },
                  'item-3': {
                    label: 'Tiến độ hoàn thành (%)',
                    type: 'Slider',
                    fieldName: 'progress',
                    min: 0,
                    max: 100,
                    step: 10,
                    color: 'green'
                  },
                  'item-4': {
                    label: 'Phòng ban phụ trách',
                    type: 'Select',
                    fieldName: 'department',
                    datasource: {
                      options: [],
                      field: 'listDep',
                      label: 'name',
                      value: 'id'
                    },
                    icon: 'store',
                    sortBy: 'name',
                    mapOptions: true,
                    clearable: true,
                    readonly: true,
                    validation: 'required'
                  },
                  'item-5': {
                    label: 'Người phụ trách',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    sortBy: 'displayName',
                    field: 'assignee',
                    name: 'assignee',
                    fieldName: 'assignee',
                    icon: 'people',
                    clearable: true,
                    readonly: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-6': {
                    label: 'Người nhận kết quả',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'required': true,
                      'email': true
                    },
                    sortBy: 'displayName',
                    field: 'reporter',
                    name: 'reporter',
                    fieldName: 'reporter',
                    icon: 'people',
                    clearable: true,
                    readonly: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-7': {
                    label: 'Người cập nhật',
                    type: 'Select',
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    validation: {
                      'email': true
                    },
                    sortBy: 'displayName',
                    field: 'assistant',
                    name: 'assistant',
                    fieldName: 'assistant',
                    icon: 'people',
                    clearable: true,
                    after: {
                      func: this.assignToMe
                    }
                  },
                  'item-8': {
                    label: 'Hạn chót',
                    type: 'DatePicker',
                    validation: 'required',
                    fieldName: 'dueDate',
                    icon: 'date_range',
                    clearable: true,
                    range: date => date >= moment().format('YYYY/MM/DD'),
                    readonly: true
                  },
                  'item-9': {
                    label: 'Nhãn',
                    type: 'Select',
                    fieldName: 'labels',
                    icon: 'label',
                    clearable: true,
                    multiple: true,
                    useChipsMultiple: true,
                    newValueMode: 'add',
                    useInput: true,
                    readonly: true
                  },
                  'item-10': {
                    label: 'Chia sẻ',
                    fieldName: 'listShareUser',
                    type: 'Select',
                    multiple: true,
                    datasource: {
                      options: [],
                      value: 'email',
                      label: 'displayName',
                      emitValue: true
                    },
                    mapOptions: true,
                    useInput: true,
                    useChipsMultiple: true,
                    icon: 'people',
                    clearable: true,
                    readonly: true
                  },
                  'item-11': {
                    label: 'Người tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.value.createdBy`,
                    watch: true
                  },
                  'item-12': {
                    label: 'Ngày tạo',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.createdTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-13': {
                    label: 'Cập nhật cuối',
                    type: 'Label',
                    fieldName: 'metaData',
                    format: `this.value && this.moment(this.value.lastModifiedTime.toDate()).fromNow()`,
                    watch: true
                  },
                  'item-14': {
                    label: 'Quá hạn',
                    type: 'Label',
                    fieldName: 'dueDate',
                    format: `(this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel' ? this.moment(this.modelProps.toDate()).fromNow() : '')`,
                    chipMode: true,
                    colorChip: `'red'`,
                    show: `this.modelProps && this.modelProps instanceof Timestamp && this.moment(this.modelProps.toDate()).isBefore() && this.rootModel.status.id !== 'done' && this.rootModel.status.id !== 'cancel'`
                  },
                  'item-15': {
                    label: 'Công việc liên quan',
                    type: 'List',
                    fieldName: 'none',
                    items: [],
                    title: 'label',
                    caption: 'caption'
                  }
                }
              ]
            }
          }
        }
      }
    }
  },
  methods: {
    assignToMe(components, value, options) {
      if(this.$store.getters.user.email) {
        components.$emit('input', this.$store.getters.user.email)
      }
    }
  },
}
</script>
